import { Button, CircularProgress } from "@mui/material";
import type { ButtonProps } from "@mui/material";

type ButtonLoaderProps = ButtonProps & {
  loading?: boolean;
  spinnerColor?: string;
  spinnerSize?: number;
  minWidth?: number | string;
  buttonColor?: string;
};

export function ButtonLoader({
  loading = false,
  spinnerColor = "#fff",
  spinnerSize = 20,
  minWidth,
  buttonColor,
  disabled,
  children,
  sx,
  ...rest
}: ButtonLoaderProps) {
  return (
    <Button
      {...rest}
      disabled={Boolean(loading || disabled)}
      aria-busy={loading}
      sx={{
        minWidth,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1, 
        ...(buttonColor && {
          backgroundColor: buttonColor,
          "&:hover": { backgroundColor: buttonColor },
        }),
        ...sx,
      }}
    >
    
      <span>{children}</span>

      
      {loading && (
        <CircularProgress
          size={spinnerSize}
          sx={{ color: spinnerColor }}
        />
      )}
    </Button>
  );
}
